/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick'
import { useRef } from 'react';
export default function FilterModal({ isFilterOpen, setIsFilterOpen, handleApplyFilter, initialState, filterValues, setFilterValues, handleOpenFilter, handleCheckboxChange }) {

   
    const ref=useRef()
    useOnClickOutside(ref, () => {
        setIsFilterOpen(false);
    });
    // Check if any checkbox is selected
    const isAnyCheckboxSelected = filterValues && Object.values(filterValues).some(
        (value) => Array.isArray(value) && value.length > 0
    );



    return (
        <div className='relative ml-2.5'>
            <button id='filter' type='button' className='flex items-center border border-[#972E4C] rounded-[15px] px-4 py-2' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen &&
                // <motion.div
                //     initial={{ opacity: 0, x: 80,y:-46 }}
                //     animate={{ opacity: 1, x: 0 ,y:-46}}
                //     transition={{ delay: 0.2, duration: 0.5 }}
                //     exit={{ opacity: 0.5 }}
                //     className='z-[999] bg-white'
                // >
                <div ref={ref} className='absolute top-14 right-0 bg-white rounded-[15px] border border-[#D296B2] px-[27px] pt-4 py-[26px] shadow-s2 w-[289px] z-[2]'>
                    <div className='flex justify-between items-center mb-4'>
                        <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                        <button type='button' onClick={() => { setIsFilterOpen(!isFilterOpen), setFilterValues(initialState) }}>
                            <img src="/images/cross_mark_gray.svg" alt="icon" />
                        </button>
                    </div>
                    <div className='flex flex-wrap justify-between items-center mb-4'>
                        <p className='text-[12px] font-semibold text-[#000]'>Permission</p>
                        {isAnyCheckboxSelected && (
                            <p id='clear_all' onClick={() => { handleApplyFilter(false), setFilterValues(initialState), setIsFilterOpen(false) }} className='text-[12px] font-semibold text-[#972E4C] cursor-pointer'>Clear All</p>
                        )}

                    </div>
                    <div className="">
                        <div className='p-[8px] flex items-center mb-4 mark-check  relative checkbox custom-checkBoxBlue1'>
                            <input
                                type='checkbox'
                                id='admin'
                                onChange={(e) => handleCheckboxChange(e, 'permission_access')}
                                checked={filterValues && filterValues.permission_access && filterValues.permission_access.includes('admin')}
                                className='h-[18px] w-[18px] cursor-pointer'
                            />                            
                            <label htmlFor='admin' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>Admin</label>
                        </div>
                        <div className='p-[8px] flex items-center mb-4 relative mark-check checkbox custom-checkBoxBlue1'>
                            <input
                                type='checkbox'
                                id='user'
                                onChange={(e) => handleCheckboxChange(e, 'permission_access')}
                                checked={filterValues && filterValues.permission_access && filterValues.permission_access.includes('user')}
                                className='h-[18px] w-[18px] cursor-pointer'
                            />
                            <label htmlFor='user' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>User</label>
                        </div>
                        <hr />
                        <p className='text-[12px] font-semibold text-[#000] mt-4 mb-4'>Status</p>
                        <div className='p-[8px] flex items-center mb-4 relative mark-check  checkbox custom-checkBoxBlue1'>
                            <input
                                type='checkbox'
                                id='active'
                                onChange={(e) => handleCheckboxChange(e, 'status')}
                                checked={filterValues && filterValues.status && filterValues.status.includes('active')}
                                className='h-[18px] w-[18px] cursor-pointer'
                            />
                            <label id='active' htmlFor='active' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>Active</label>
                        </div>
                        <div className='p-[8px] flex items-center mb-4 mark-check  relative checkbox custom-checkBoxBlue1'>
                            <input
                                type='checkbox'
                                id='inactive'
                                onChange={(e) => handleCheckboxChange(e, 'status')}
                                checked={filterValues && filterValues.status && filterValues.status.includes('inactive')}
                                className='h-[18px] w-[18px] cursor-pointer'
                            />
                            <label id='inactive' htmlFor='inactive' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>Inactive</label>
                        </div>
                        <hr className='mb-4'/>
                        <button
                            id='apply-filter'
                            onClick={() => {
                                handleApplyFilter(true), setIsFilterOpen(false);
                            }}
                            type='button'
                            disabled={
                                !filterValues ||
                            !Object.values(filterValues).some(
                                (value) => Array.isArray(value) && value.length > 0
                            )
                            }
                            className={`py-2.5 px-4 rounded-[16px] ${
                                !filterValues ||
                                !Object.values(filterValues).some(
                                    (value) => Array.isArray(value) && value.length > 0
                                )
                                    ? 'bg-[#777C88]'
                                    : 'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'
                            } w-full text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}
                        >
                            Apply
                        </button>

                    </div>
                </div>
                // </motion.div>
            }
        </div>
    )
}
